// src/components/SplashScreen.jsx
import React from 'react'
import './SplashScreen.css'

const SplashScreen = () => {
  return (
    <div className="splash-screen">
      <h1 className="splash-logo">Adit Sharma</h1>
    </div>
  )
}

export default SplashScreen
